import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { useEffect, useState } from "react";
import { SOLUTION_AVATARS as AVATARS } from "../constants/solutionAvatars";

// Quantos rostos aparecem por vez: 4 cabem no card estreito do desktop.
const VISIBLE = 4;
const ROTATE_MS = 1600;

type MessagesAvatarStackProps = {
  /** Gira a fila só enquanto o disparo está rodando e o card está na tela. */
  active: boolean;
};

export function MessagesAvatarStack({ active }: MessagesAvatarStackProps) {
  const reduceMotion = useReducedMotion();
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    if (!active || reduceMotion) return;
    const id = window.setInterval(() => setOffset(prev => prev + 1), ROTATE_MS);
    return () => window.clearInterval(id);
  }, [active, reduceMotion]);

  // Quem está na frente "recebeu" a mensagem e sai; o próximo da fila entra
  // no fim da pilha.
  const visible = Array.from(
    { length: VISIBLE },
    (_, position) => AVATARS[(position + offset) % AVATARS.length]
  );

  return (
    <div className="flex -space-x-3 sm:-space-x-4">
      <AnimatePresence initial={false} mode="popLayout">
        {visible.map((src, position) => (
          <motion.img
            key={src}
            layout={!reduceMotion}
            src={src}
            alt=""
            width={44}
            height={44}
            loading="lazy"
            decoding="async"
            style={{ zIndex: VISIBLE - position }}
            initial={{ opacity: 0, scale: 0.6 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.6 }}
            transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
            className="ring-ds-paper-marketing bg-ds-ink-100 size-10 shrink-0 rounded-full object-cover ring-2 sm:size-11"
          />
        ))}
      </AnimatePresence>
    </div>
  );
}
